import { EGarageMaterial } from '../../../../json_query';
import { changeGarageMaterial } from '../../../state/advanced/garage_material';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const GarageMaterialParam = getMultiSelectParam<EGarageMaterial>(
  'Тип бокса',
  [
    { title: 'Металлический', value: EGarageMaterial.Metal },
    { title: 'Кирпичный', value: EGarageMaterial.Brick },
  ],
  'garage_material',
  changeGarageMaterial,
);
